const ChoosingCareerChallenge2InitialText ="There are several factors that might influence " +
    "your career choice.  Review and prioritize the items in the 'Considerations' column. " +
    "The item that should have the most impact on your career choice will be at the top of the list " +
    "and the item that should have the least impact on your decision will be at the bottom of " +
    "the list.  Click the <Done> button to check your response." 
    
export default ChoosingCareerChallenge2InitialText 
 